/* ============================================================================
   CREDIT CALCULATOR
   Computes an equal-monthly-payment (annuity) amortization schedule for the
   "Ապառիկով" / credit price shown on the product page, and renders it inside
   a native <dialog> modal.
   ============================================================================ */
(function () {
  'use strict';

  function formatNumber(amount) {
    var rounded = Math.round(amount || 0);
    var negative = rounded < 0;
    var withSpaces = Math.abs(rounded).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (negative ? '-' : '') + withSpaces;
  }

  function formatMoney(amount, symbol) {
    var formatted = formatNumber(amount);
    return symbol ? formatted + ' ' + symbol : formatted;
  }

  // Standard reducing-balance (annuity) amortization: equal total payment
  // each month, with the interest/principal split shifting over time.
  function computeSchedule(principal, annualRatePercent, months) {
    var monthlyRate = (parseFloat(annualRatePercent) || 0) / 100 / 12;
    var payment;

    if (monthlyRate === 0) {
      payment = principal / months;
    } else {
      payment = (principal * monthlyRate) / (1 - Math.pow(1 + monthlyRate, -months));
    }

    var rows = [];
    var balance = principal;

    for (var i = 1; i <= months; i++) {
      var interest = balance * monthlyRate;
      var principalPortion;
      var total;

      if (i === months) {
        // Last month absorbs any rounding drift so the balance reaches exactly 0.
        principalPortion = balance;
        total = principalPortion + interest;
      } else {
        principalPortion = payment - interest;
        total = payment;
      }

      balance -= principalPortion;

      rows.push({
        month: i,
        interest: interest,
        principal: principalPortion,
        total: total
      });
    }

    return rows;
  }

  function CreditCalculator(el) {
    this.el = el;
    this.dialog = el.closest('dialog');
    this.creditPrice = parseFloat(el.getAttribute('data-credit-price')) || 0;
    this.annualRate = parseFloat(el.getAttribute('data-annual-rate')) || 0;
    this.currencySymbol = el.getAttribute('data-currency-symbol') || '';

    this.downPaymentInput = el.querySelector('[data-credit-calculator-down-payment]');
    this.termSelect = el.querySelector('[data-credit-calculator-term]');
    this.calculateButton = el.querySelector('[data-credit-calculator-calculate]');
    this.resultsWrap = el.querySelector('[data-credit-calculator-results]');
    this.tbody = el.querySelector('[data-credit-calculator-tbody]');
    this.monthlyPaymentEl = el.querySelector('[data-credit-calculator-monthly-payment]');
    this.totalEl = el.querySelector('[data-credit-calculator-total]');

    var self = this;

    if (this.calculateButton) {
      this.calculateButton.addEventListener('click', function (event) {
        event.preventDefault();
        self.calculate();
      });
    }

    if (this.termSelect) {
      this.termSelect.addEventListener('change', function () {
        self.calculate();
      });
    }

    this.calculate();
  }

  CreditCalculator.prototype.getInputs = function () {
    // The credit price always comes from the product's admin-set metafield — it is
    // never an editable field on the storefront, only the down payment and term are.
    var price = this.creditPrice;
    var downPayment = parseFloat(this.downPaymentInput && this.downPaymentInput.value) || 0;
    var months = parseInt(this.termSelect && this.termSelect.value, 10) || 12;

    if (downPayment < 0) downPayment = 0;
    if (price > 0 && downPayment > price) downPayment = price;

    return { price: price, downPayment: downPayment, months: months };
  };

  CreditCalculator.prototype.calculate = function () {
    var inputs = this.getInputs();
    var principal = Math.max(inputs.price - inputs.downPayment, 0);
    var rows = principal > 0 ? computeSchedule(principal, this.annualRate, inputs.months) : [];

    if (this.tbody) {
      var html = '';

      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        html += '<tr>' +
          '<td>' + row.month + '</td>' +
          '<td>' + formatNumber(row.interest) + '</td>' +
          '<td>' + formatNumber(row.principal) + '</td>' +
          '<td class="credit-calculator__total-cell">' + formatNumber(row.total) + '</td>' +
          '</tr>';
      }

      this.tbody.innerHTML = html;
    }

    if (this.resultsWrap) {
      this.resultsWrap.hidden = rows.length === 0;
    }

    if (this.monthlyPaymentEl) {
      this.monthlyPaymentEl.textContent = rows.length ? formatMoney(rows[0].total, this.currencySymbol) : '—';
    }

    if (this.totalEl) {
      var totalSum = inputs.downPayment;
      for (var j = 0; j < rows.length; j++) {
        totalSum += rows[j].total;
      }
      this.totalEl.textContent = rows.length ? formatMoney(totalSum, this.currencySymbol) : '—';
    }
  };

  function bindDialogDismissal(dialog) {
    // Close when clicking the backdrop (a click lands on the <dialog> element
    // itself only when it's outside the inner content wrapper).
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  }

  function bindTriggers() {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-credit-calculator-open]');

      if (opener) {
        var dialogId = opener.getAttribute('data-credit-calculator-open');
        var dialog = document.getElementById(dialogId);

        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
        }

        return;
      }

      var closer = event.target.closest('[data-credit-calculator-close]');

      if (closer) {
        var parentDialog = closer.closest('dialog');
        if (parentDialog) parentDialog.close();
      }
    });
  }

  function init() {
    var calculators = document.querySelectorAll('[data-credit-calculator]');

    calculators.forEach(function (el) {
      new CreditCalculator(el);

      var dialog = el.closest('dialog');
      if (dialog) bindDialogDismissal(dialog);
    });

    bindTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
